import { Component, ViewContainerRef } from "@angular/core";
import { Router } from "@angular/router";
import { ToastsManager } from "ng2-toastr/ng2-toastr";
import { Constants } from "./constants/constants";
import { Roles } from "./enums/enums";
import { AirFreightRoles } from "./enums/enums";
import { AuthenticationService } from "./authentication/authentication.service";

@Component({
	selector: "app",
	templateUrl: "/app/app.template.html"
})
export class AppComponent {
	isMenuVisible = false;

	constructor(private router: Router, private toast: ToastsManager, private constants: Constants, vref: ViewContainerRef, private authService: AuthenticationService) {
		this.toast.setRootViewContainerRef(vref);
	}

	showHideMenu() {
		this.isMenuVisible = !this.isMenuVisible;
	}

	hideMenuOnMouseLeave() {
		this.isMenuVisible = false;
	}

	logout() {
		this.toast.success("You have been logged out.", "Logged Out", { toastLife: 5000 });
		localStorage.removeItem("user");
		localStorage.removeItem("returnUrl");
		this.isMenuVisible = false;
		this.constants.user = null;
		this.authService.logout();
		this.router.navigate(["/"]);
	}

	isIndex(): boolean {
		return this.router.url !== "/";
	}

	hasPermission(role: Roles): boolean {
		return (this.constants.user.role & (role as number)) === (role as number);
	}

	hasBudgetManagerRole(): boolean {
		return this.hasPermission(Roles.BudgetManager);
	}

	hasPurchaserRole(): boolean {
		return this.hasPermission(Roles.Purchaser);
	}

	hasDefaultRole(): boolean {
		return this.hasPermission(Roles.Default);
	}

	hasApManagerRole(): boolean {
		return this.hasPermission(Roles.ApMangaer);
    }

    hasAirPermission(role: AirFreightRoles): boolean {
        return (this.constants.user.airfreightrole & (role as number)) === (role as number);
    }

    hasAirFreight(): boolean {
        return this.hasAirPermission(AirFreightRoles.Default);        
    };
    hasAirTraffic(): boolean {
        return this.hasAirPermission(AirFreightRoles.Traffic);
    };
    hasAirApprover(): boolean {
        return this.hasAirPermission(AirFreightRoles.BudgetManager);
	};
	loadHelpDocument(): void {
		window.open(Constants.helpGuideDocumentUrl, '_blank');
	}
}